// extracted by mini-css-extract-plugin
module.exports = {"prev":"Preview3D_prev__fI_gW"};